export default __webpack_public_path__ + "static/media/logo.f774a3ed.svg";